import { rpc } from "./Rpc";

export const someCompThatDoesNotLimitRefAccessHasUpcomingGames = rpc<void, {someCompThatDoesNotLimitRefAccessHasUpcomingGames: boolean}>("get", "v1/misc/someCompThatDoesNotLimitRefAccessHasUpcomingGames");
